import axios from "axios";
import { useContext, useEffect, useState } from "react";
import logger from "../utilitis/logger";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Grid from "@mui/material/Grid";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import Stack from "@mui/material/Stack";
import { useParams } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import { useNavigate } from "react-router-dom";
import HomeButton from "../component/HomeButton";
import { MainContext } from "../context/OpenInvoice";

function GoodUrl() {
  const heightDisplay = window.innerHeight;
  const [state, dispatch] = useContext(MainContext);
  const boxSize = heightDisplay - 210;
  const [debitApproveNumber, setDebitApproveNumber] = useState();
  const navigate = useNavigate();
  const {
    PelecardTransactionId,
    PelecardStatusCode,
    ApprovalNo,
    Token,
    ConfirmationKey,
    ParamX,
    UserKey,
  } = useParams();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const TransactionId = params.get("PelecardTransactionId");
    const StatusCode = params.get("PelecardStatusCode");
    const ConfirmationKey = params.get("ConfirmationKey");

    async function fetchData() {
      try {
        const response = await axios.post("/payments/validate_pelecard", {
          ConfirmationKey: ConfirmationKey,
          TransactionId: TransactionId,
          ApprovalNo: ApprovalNo,
          withCredentials: true,
        });

        let response_data = response.data;
        if (response_data.status == 401) {
          navigate("/error");
        }
        setDebitApproveNumber(response_data["DebitApproveNumber"]);
        dispatch({
          type: "DATA_RESPONSE",
          payload: {
            value: [],
          },
        });
      } catch (error) {
        logger.error(error);
      }
    }
    fetchData();
  }, []);

  return (
    <Container>
      {debitApproveNumber ? (
        <Dialog open={true}>
          <Box
            sx={{
              padding: "1rem",
              borderRadius: "16px",
              bgcolor: "#f5f6fa",
              height: boxSize + "px",
              overflow: "auto",
            }}
          >
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              sx={{ marginTop: "3rem", marginBottom: "1rem" }}
            >
              <CheckCircleOutlineIcon
                sx={{ color: "green", width: "20%", height: "20%" }}
              />
            </Grid>
            <Typography variant="h5" sx={{ textAlign: "center" }}>
              {" "}
              התשלום עבר בהצלחה
            </Typography>
            <Box
              sx={{
                borderRadius: "16px",
                bgcolor: "#FFFFFF",
                marginTop: "1rem",
                boxShadow: 1,
              }}
            >
              <br />
              <Typography
                variant="h5"
                sx={{ textAlign: "center", fontWeight: "bold" }}
              >
                מספר אישור
              </Typography>
              <Typography
                variant="h5"
                sx={{ textAlign: "center", fontWeight: "bold" }}
              >
                {debitApproveNumber}
              </Typography>
              <br />
              <Typography variant="h6" sx={{ textAlign: "center" }}>
                קבלה נשלח לך למייל
              </Typography>
              <Typography variant="h6" sx={{ textAlign: "center" }}>
                לבירורים ופרטים נוספים ניתן לפנות
                <br />
                <Stack
                  direction="row"
                  spacing={1}
                  justifyContent="center"
                  alignItems="center"
                >
                  <LocalPhoneIcon />
                  <p> 03-9264855</p>
                </Stack>
              </Typography>
              <br />
            </Box>
            <HomeButton />
          </Box>
        </Dialog>
      ) : null}
    </Container>
  );
}

export default GoodUrl;
